import { PathBase } from "@constellation-academy/epic-ui";

export class StagingPath extends PathBase {
	static readonly pathKey = "staging";
}
